/*
Detta sätter min-height på matane-main så att footer inte "hänger" i mitten vertikalt. Detta fixar så att alltid sidfoten håller sig nere.
*/

function setMinHeightSiteMain() {
	const siteMainElement = document.querySelector(".matane-main");
	const siteFooterElement = document.querySelector(".matane-footer");
	const siteFooterElementHeight = siteFooterElement.scrollHeight;
	const siteMainElementHeight = `calc(100vh - ${siteFooterElementHeight}px)`;
	siteMainElement.style.minHeight = siteMainElementHeight;
	console.log(siteFooterElementHeight);
}
setMinHeightSiteMain();

window.addEventListener("resize", () => {
	setMinHeightSiteMain();
});
